<template>
    <div class="text-indigo-500 hover:text-indigo-700 cursor-pointer transition-all">
        <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" class="size-6 transition-all" preserveAspectRatio="xMidYMid meet">
            <!-- Background -->
            <rect width="100" height="100" fill="currentColor" rx="50"/>
            
            <!-- Simple waveform -->
            <g transform="translate(10, 40)">
                <rect x="0" y="0" width="8" height="20" fill="rgb(255 255 255)" rx="4"/>
                <rect x="12" y="-10" width="8" height="40" fill="rgb(255 255 255)" rx="4"/>
                <rect x="24" y="4" width="8" height="12" fill="rgb(255 255 255)" rx="4"/>
                <rect x="36" y="-16" width="8" height="52" fill="rgb(255 255 255)" rx="4"/>
                <rect x="48" y="-4" width="8" height="28" fill="rgb(255 255 255)" rx="4"/>
                <rect x="60" y="2" width="8" height="16" fill="rgb(255 255 255)" rx="4"/>
                <rect x="72" y="-12" width="8" height="44" fill="rgb(255 255 255)" rx="4"/>
            </g>
        </svg>
    </div>
</template>